import clientAPI from '../../../api/client'
import modulesAPI from '../../../api/modules'
import componentsAPI from '../../../api/components'
import * as errorMessages from '../../../error-messages'

export default {
  async getMe({commit}) {
    commit('setFetchingMe', true)
    const resp = await clientAPI.getMe()
    commit('setClientData', resp.data.data)
    commit('setFetchingMe', false)
  },

  async updateMe({commit, state, rootState}) {
    commit('forms/profile/resetErrors')
    commit('forms/profile/resetSuccess')

    const data = {}
    if (state.forms.profile.fields.name) {
      data.name = state.forms.profile.fields.name
    }

    if (
      state.forms.profile.fields.email &&
      state.forms.profile.fields.email !== rootState.client.data.email
    ) {
      data.email = state.forms.profile.fields.email
    }

    if (state.forms.profile.fields.password) {
      data.password = state.forms.profile.fields.password
    }

    try {
      commit('forms/profile/setSaving', true)

      await clientAPI.updateMe({data})
      const resp = await clientAPI.getMe()
      commit('setClientData', resp.data.data)
      commit('forms/profile/setSuccess', true)
    } catch (err) {
      commit('forms/profile/setSuccess', false)

      if (err.response && err.response.status === 422) {
        const errors = err.response.data.errors
        commit('forms/profile/setErrors', errors)
      }
    } finally {
      commit('forms/profile/setSaving', false)
    }
  },

  async requestAccess({commit, state}) {
    commit('forms/accessRequest/resetErrors')
    commit('forms/accessRequest/resetSuccess')

    const data = {
      name: state.forms.accessRequest.fields.name
    }

    try {
      commit('forms/accessRequest/setSaving', true)

      await clientAPI.requestAccess({data})
      commit('forms/accessRequest/setField', {
        field: 'name',
        value: null
      })
      commit('forms/accessRequest/setSuccess', true)
    } catch (err) {
      commit('forms/accessRequest/setSuccess', false)

      if (err.response && err.response.status === 422) {
        const errors = err.response.data.errors
        commit('forms/accessRequest/setErrors', errors)

        if (errors.tenant_id) {
          if (errors.tenant_id[0].indexOf('removed') !== -1) {
            commit('forms/accessRequest/setFieldErrors', {
              field: 'other',
              errors: [errorMessages.REMOVED_FROM_ORG]
            })
          }

          // already a member
          if (errors.tenant_id[0].indexOf('associated') !== -1) {
            commit('forms/accessRequest/setFieldErrors', {
              field: 'other',
              errors: [errorMessages.ALREADY_A_MEMBER]
            })
          }

          // already requested access
          if (errors.tenant_id[0].indexOf('submitted') !== -1) {
            commit('forms/accessRequest/setFieldErrors', {
              field: 'other',
              errors: [errorMessages.ALREADY_REQUESTED]
            })
          }
        }
      }
    } finally {
      commit('forms/accessRequest/setSaving', false)
    }
  },

  async resendConfirmation({commit}) {
    // reset the status
    commit('setConfirmationSent', false)
    await clientAPI.resendConfirmation()
    commit('setConfirmationSent', true)
  },

  async getContentTree({commit, rootState}) {
    const tenantID = rootState.tenants.current.id
    commit('setFetchingContentTree', true)
    const resp = await clientAPI.contentTree({tenantID})
    commit('setContentTree', resp.data.data)
    commit('setFetchingContentTree', false)
  },

  async updateHiddenState({commit, state, rootState}, {moduleID, componentID, hidden}) {
    const tenantID = rootState.tenants.current.id
    if (componentID) {
      if (hidden) {
        componentsAPI.hide({tenantID, moduleID, componentID})
      } else {
        componentsAPI.unhide({tenantID, moduleID, componentID})
      }
    } else {
      if (hidden) {
        modulesAPI.hide({tenantID, moduleID})
      } else {
        modulesAPI.unhide({tenantID, moduleID})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client/actions.js